<template lang="pug">
  nav.navbar.is-light(role='navigation' aria-label='main navigation')
    .navbar-brand
      a.navbar-item(to="/")
        img(src='../assets/logoVirus.png' alt='Icon' width='38' height='28')
      a#navBurger.navbar-burger.burger(
        role='button',
        aria-label='menu',
        aria-expanded='false',
        data-target='navbarMenu',
        @click="displayBurger")
        span(aria-hidden='true')
        span(aria-hidden='true')
        span(aria-hidden='true')
    #navbarMenu.navbar-menu
      .navbar-start
        a.navbar-item
          i.fas.fa-home
          | &nbsp Covid-19
</template>

<script>
export default {
  name: 'Navbar',
  methods: {
    displayBurger() {
      const burger = document.getElementById('navBurger')
      const nav = document.getElementById(burger.dataset.target)
      burger.classList.toggle('is-active')
      nav.classList.toggle('is-active')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
